import { Injectable } from '@angular/core';
import YAML from 'yaml';

@Injectable()
export class DownloadAppService {
  url: string = 'https://s3-eu-west-1.amazonaws.com/mojob-apps/';

  constructor() {}

  getLatestVersion(platform) {
    let latestUrl = 'latest.yml';
    if (platform === 'mac') {
      latestUrl = 'latest-mac.yml';
    }

    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        const response = YAML.parse(xhr.response);
        const versionPath = response.path.split(' ').join('+');
        window.open(this.url + versionPath, 'Download');
      } else {
        console.log(xhr);
      }
    };
    xhr.open('GET', this.url + latestUrl);
    xhr.send();
  }
}
